module.exports = __webpack_public_path__ + "img/badge_fringe_app_main_level.41c33846.jpg";